import { useQuery } from '@tanstack/react-query'

import { Card, ErrorText, Spinner } from '@/components/ui'

import { apiUsers, usersKey } from './api'

const DATA_LABELS: Record<string, string> = {
  sessions: 'Тренировки', sets: 'Подходы', templates: 'Шаблоны', metric_samples: 'Замеры',
  inbody_scans: 'Замеры InBody', lab_results: 'Анализы', files: 'Файлы',
}

export function UserDataStats({ id }: { id: string }) {
  const stats = useQuery({ queryKey: [...usersKey, id, 'stats'], queryFn: () => apiUsers.stats(id) })

  return <Card title="Данные пользователя" subtitle="Только количества записей; личные названия и значения не показываются.">
    {stats.isPending ? <Spinner /> : stats.isError ? <ErrorText error={stats.error} /> : <dl className="grid grid-cols-2 gap-4 text-sm sm:grid-cols-3">
      {Object.entries(stats.data.data_counts).map(([key, count]) => <div key={key}>
        <dt className="text-muted">{DATA_LABELS[key] ?? key}</dt>
        <dd className="mt-1 font-semibold tabular-nums">{count.toLocaleString('ru-RU')}</dd>
      </div>)}
    </dl>}
  </Card>
}
